// src/plugins/2.router/index.js
// eslint-disable-next-line import/no-unresolved -- vite-plugin-vue-layouts supplies this virtual module.
import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router/auto'
import { routes as generated } from 'vue-router/auto-routes'
import { redirects, routes as extraRoutes } from './additional-routes'
import { setupGuards } from './guards'
import { installPageTitle } from './pageTitle'
import { installPasswordLinkCleanup } from './passwordLinkCleanup'
import { scrollBehavior } from './scrollBehavior'
import { installSessionEndedNavigation } from './sessionEndedNavigation'
import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'
import { useRouterStore } from '@/@vxapp/@Utils/useRouterStore'

function recursiveLayouts(route) {
  if (route.children) {
    route.children = route.children.map(recursiveLayouts)

    return route
  }

  return setupLayouts([route])[0]
}

const allRoutes = [...redirects, ...generated, ...extraRoutes].map(recursiveLayouts)

// 2) hand that to createRouter
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior,
  routes: allRoutes,
})

setupGuards(router)
installPasswordLinkCleanup(router)
installPageTitle(router)
installSessionEndedNavigation(router, () => useAuthStore())

export { router }
export default function (app) {
  app.use(router)

  const routerStore = useRouterStore()

  routerStore.initializeRouterTracking(router)
}
